import React, { useCallback } from "react";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form } from "react-final-form";
import Validator from "../../../../_helpers/validate.schema";
import { UiCol } from "../../../_uiComponents/grid-container/GridContainer";
import { UiInput, UiInputLink } from "../../../_uiComponents/form/UiInput";
import { getFingerPrint } from "../../../../_helpers/support.services";
import { UiButton, UiButtonPrimary } from "../../../_uiComponents/form/UiButton";
import { loginAuthRequest } from "../../../../_redux/_actions";
import UiInlineSuccessMessage from "../../../_uiComponents/form/UiInlineSuccessMessage"

const validateSchema = () =>
    yup.object().shape({
        // currentPassword: yup.string().required("Current Password is required."),
        // newPassword: yup.string().required("New Password is required."),
        // confirmedNewPassword: yup.string().required("Confirm Password is required."),
    });

const onValidate = async (values) => {
    return await Validator(values, validateSchema);
};

export default function ChangeProfileName(props) {

    const submit = async (values) => {
        const payload = {
            firstName:values?.firstName ? values?.firstName : "" ,
            lastName:values.LastName ? values.LastName : '',
        }
        props.changeProfileName(payload);

    };

    return (
        <Form
            onSubmit={submit}
            validate={onValidate}
            initialValues={{
                firstName:props?.userDetails?.firstName,
                LastName:props?.userDetails?.lastName,
            }}
            render={({ handleSubmit, hasValidationErrors }) => (
                <form onSubmit={validateSchema}>
                    <UiInlineSuccessMessage/>
                    <UiCol lg="12">
                        <UiInput type="text" name="firstName" placeholder="First Name"/>
                    </UiCol>
                    <UiCol lg="12">
                        <UiInput type="text" name="LastName" placeholder="Last Name"/>
                    </UiCol>

                    <UiCol lg="12">
                        <div className="sb-prof-pwd-update-btn">
                            <UiButtonPrimary
                                btnName={"Save"}
                                onClick={handleSubmit}
                            />
                            <UiButtonPrimary
                                btnName={"Cancel"}
                                onClick={() => {props.setNameEditMode(false)}}
                            />
                        </div>
                    </UiCol>
                </form>
            )}
        />
    );
}
